import { render, staticRenderFns } from "./ContaContaForm.vue?vue&type=template&id=5e5c0d1c"
import script from "./ContaContaForm.vue?vue&type=script&lang=js"
export * from "./ContaContaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports